import { lazy } from 'react';

import { Navigate, Outlet } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';

const CommerceTable = Loadable(lazy(() => import('pages/commerce/commerceTable')));
const CommerceCompanyProfile = Loadable(lazy(() => import('pages/commerce/company')));
const TabCompany = Loadable(lazy(() => import('sections/apps/profiles/commerce/TabCompany')));
const TabCompanyAnalytics = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyAnalytics')));
const TabCompanyContacts = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyContacts')));

// ==============================|| APPS ROUTING ||============================== //

const CommerceRoutes = {
  path: '/',
  element: (
    <ContactsProvider>
      <Outlet />
    </ContactsProvider>
  ),
  children: [
    {
      path: '/commerce',
      element: <CommerceTable />
    },
    {
      path: '/commerce/:id',
      element: <CommerceCompanyProfile />,
      children: [
        {
          path: '',
          element: <Navigate to="details" />
        },
        {
          path: 'details',
          element: <TabCompany />
        },
        {
          path: 'contacts',
          element: <TabCompanyContacts />
        },
        {
          path: 'analytics',
          element: <TabCompanyAnalytics />
        }
      ]
    }
  ]
};

export default CommerceRoutes;
